/**
 * The caller's leave approval capabilities (line approver, HR final approver,
 * sole HR admin, counts). Shares one react-query entry with
 * `<LeaveApprovalBadgeSubscriber />`, so pages and the sidebar badges read the
 * same baseline.
 */

import { useQuery } from '@tanstack/react-query';
import { useLeaveApprovalService } from '@actschurch/ccms-sdk';
import { hrKeys } from '../../utils/queryKeys';

export function useLeaveApprovalCapabilities(enabled = true) {
  const service = useLeaveApprovalService();
  return useQuery({
    queryKey: hrKeys.leaveApprovals.capabilities(),
    queryFn: () => service.getCapabilities(),
    staleTime: 30 * 1000,
    enabled,
  });
}
